export default __webpack_public_path__ + "static/caps-731a7a6dc0b87e0e4f5198c7b3cb64b7.png";